'use client';

import Link from 'next/link';
import { useConsent } from '@/lib/consent';

export function CookieBanner() {
  const { consent, accept, decline } = useConsent();

  if (consent !== 'pending') return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-3 bottom-16 z-40 mx-auto max-w-2xl border border-outline-variant bg-surface-container-lowest/95 p-4 shadow-2xl backdrop-blur-md"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-on-surface-variant">
          We use a small set of cookies and similar tools to make this work and to understand how it
          gets used. Details in the{' '}
          <Link href="/privacy" className="text-primary hover:underline underline-offset-2">
            privacy notice
          </Link>
          .
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            onClick={decline}
            className="border border-outline-variant px-3 py-1.5 font-mono text-[10px] tracking-widest text-on-surface-variant hover:border-outline hover:text-on-surface transition-colors"
          >
            ESSENTIAL ONLY
          </button>
          <button
            onClick={accept}
            className="bg-primary-bright px-3 py-1.5 font-mono text-[10px] font-bold tracking-widest text-on-primary hover:bg-primary transition-colors"
          >
            ACCEPT ALL
          </button>
        </div>
      </div>
    </div>
  );
}
